module.exports = __webpack_public_path__ + "img/rice-1.de678dc2.jpg";